import { API_HEADER, api as axios } from 'js/modules/axios'
import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function evidenciaService() {
  const api = () => useApi()

  function getEvidencia(id) {
    return api().query(`${URLS.evidencia}${id}/`)
  }

  function getAgrupamentoEnvio(params) {
    return api().query(`${URLS.agrupamento_envio}`, params)
  }

  function getAgrupamentoPeriodo(id) {
    return api().query(`${URLS.evidencia}${id}/anteriores/`)
  }

  function postEvidencia(data) {
    return api().mutation(`${URLS.evidencia}`, 'POST', data)
  }

  function patchEvidencia(id, data) {
    return api().mutation(`${URLS.evidencia}${id}/`, 'PATCH', data)
  }

  function postEvidenciaFile(data, config = {}) {
    return axios.post(`${URLS.evidencia_file}`, data, {
      headers: {
        ...API_HEADER,
        'Content-Type': 'multipart/form-data',
      },
      ...config,
    })
  }

  /** @param {import('../types/pergunta').StatusEvidencia} data */
  function postStatusEvidencia(data) {
    return api().mutation(
      `${URLS.evidencia_muda_status}`,
      'POST',
      data
    )
  }

  return {
    getEvidencia,
    postEvidencia,
    postEvidenciaFile,
    postStatusEvidencia,
    patchEvidencia,
    getAgrupamentoEnvio,
    getAgrupamentoPeriodo,
  }
}
